import { INGRadioGroupProps } from "../../library/NGFieldExtensions";
import { FormControlLabel, RadioGroup as MUIRadioGroup, Radio } from "@mui/material";
import { signal, useSignal } from "@preact/signals-react";
import { setupHandlers, setupLocalState } from "../../library/dataService";
import { getClassName, getsxObject, getTestId, isNullOrEmpty, partitionMUIClasses } from "../../library/utils";
import { isNil, isObject } from "lodash-es";
import { publishUserAction } from "../../library/analytics";
import { log } from "../../library/logger";

export default function NGRadioGroup({ context, config }: INGRadioGroupProps) {
  const tag = "NGRadioGroup";
  const local = setupLocalState(
    config,
    {
      Value: useSignal(config.Value ?? ""),
      MultiSelectPossibleValues: useSignal(config.MultiSelectPossibleValues ?? []),
      Classes: useSignal(config.Classes ?? ""),
      Style: useSignal(config.Style ?? {}),
    },
    context
  );

  const handlers = setupHandlers(config, context);

  return (
    <>
      <MUIRadioGroup
        data-testid={getTestId(config)}
        value={local.Value.value}
        {...handlers}
        onChange={(e) => {
          const v = e.target.value;
          try {
            local.Value.value = v;
          } catch (error) {
            log.warn(tag, "Error setting value", error);
          }
          const [_, classes] = partitionMUIClasses(local.Classes.value);
          const action = publishUserAction(config, context, "radio_group_change", null, {
            Value: v,
            EventCategory: "engagement",
            ElementClass: classes.join(" "),
          });
          if (handlers["onChange"]) handlers["onChange"](e, v, action);
        }}
        sx={getsxObject(local.Style.value)}
        className={getClassName(local.Classes)}
      >
        {(local.MultiSelectPossibleValues.value ?? [])?.map((datum: any, index) => {
          let label = datum;
          let value = datum;

          if (isObject(datum) && !isNil(config.ValueExpression) && !isNil(config.LabelExpression)) {
            label = datum[config.LabelExpression];
            value = datum[config.ValueExpression];
          }

          return <FormControlLabel label={label} key={index} value={value} control={<Radio color="primary" />} />;
        })}
      </MUIRadioGroup>
    </>
  );
}
